import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { ERROR_HANDLERS } from "./error-handler-distributor";

@Injectable()
export class ChunkFailedErrorHandler extends ErrorHandler {
  constructor(private injector: Injector) {
    super();
  }

  override handleError(error: any) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      this.toastrService
        .info("Die Seite muss neu geladen werden, da eine neue Version der Website verfügbar ist", "Neu laden", {
          progressBar: true,
        })
        .onHidden.subscribe(() => {
          window.location.reload();
        });
    }
  }

  private get toastrService(): ToastrService {
    return this.injector.get(ToastrService);
  }
}

export const chunkFailedErrorHandlerProvider = {
  provide: ERROR_HANDLERS,
  useClass: ChunkFailedErrorHandler,
  multi: true,
};
